import { ReactiveValue } from '@app/packages/reactives/ReactiveValue'

export class ForegroundTracker {
  readonly isForeground = new ReactiveValue<boolean>(false)
  private stack = new DisposableStack()

  constructor() {
    const updateForeground = () => {
      this.isForeground.update(() => document.visibilityState === 'visible')
    }
    // `pagehide` fires while `visibilityState` still reads visible.
    const leave = () => {
      this.isForeground.update(() => false)
    }

    updateForeground()

    document.addEventListener('visibilitychange', updateForeground)
    this.stack.defer(() => document.removeEventListener('visibilitychange', updateForeground))
    window.addEventListener('pageshow', updateForeground)
    this.stack.defer(() => window.removeEventListener('pageshow', updateForeground))
    window.addEventListener('pagehide', leave)
    this.stack.defer(() => window.removeEventListener('pagehide', leave))
  }

  [Symbol.dispose]() {
    this.stack.dispose()
  }
}
